import axios from 'axios';

import cfac22 from '../cfac22';

export default function addFavorite(uId, id, type) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      patch(

        `${cfac22('API_HOST_V2')}/users/favorites`,
        {
          payload: { id, type }
        },
        { headers: { 'Full-Url': window.location.href }, withCredentials: true }
      ).
      then((result) => {
        // console.log("RESULT_ADD_FAVORITES: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_ADD_FAVORITES: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKE:", error);
      reject(error);
    });
  });
}
